// Orenza Skeleton primitives — replace "Loading…" text everywhere.
// Brand: separation by colour (Snow → Frost), animated via `animate-pulse`.
//
// Usage:
//   <TableSkeleton rows={8} />              // table rows
//   <BlockSkeleton h={28} />                // generic block
//   <CardGridSkeleton cols={4} rows={1} />  // KPI strip
//
// All variants use bg-frost so they sit naturally inside our Snow page background.

import { cn } from '@/lib/cn';

export function BlockSkeleton({ h = 28, className }: { h?: number; className?: string }) {
  return <div className={cn('rounded-md bg-frost animate-pulse', className)} style={{ height: `${h}px` }} />;
}

export function TableSkeleton({ rows = 8, height = 32, className }: { rows?: number; height?: number; className?: string }) {
  return (
    <div className={cn('space-y-2 px-4 py-3', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-sm bg-frost animate-pulse" style={{ height: `${height}px`, opacity: 1 - i * 0.06 }} />
      ))}
    </div>
  );
}

export function CardGridSkeleton({ cols = 4, rows = 1, h = 96 }: { cols?: number; rows?: number; h?: number }) {
  return (
    <div className="grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {Array.from({ length: cols * rows }).map((_, i) => (
        <div key={i} className="rounded-md bg-frost animate-pulse" style={{ height: `${h}px` }} />
      ))}
    </div>
  );
}

export function PageSkeleton({ kind = 'table' }: { kind?: 'table' | 'report' | 'detail' }) {
  if (kind === 'report') return (
    <div className="space-y-4">
      <CardGridSkeleton cols={3} h={88} />
      <BlockSkeleton h={400} />
    </div>
  );
  if (kind === 'detail') return (
    <div className="space-y-4">
      <BlockSkeleton h={120} />
      <CardGridSkeleton cols={4} h={96} />
      <BlockSkeleton h={320} />
    </div>
  );
  return <TableSkeleton rows={10} />;
}
